function mountSignupTimezone(): void {
  document.querySelectorAll<HTMLInputElement>("[data-timezone-field]").forEach((field) => {
    try {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      if (timezone) field.value = timezone
    } catch {
      field.value = ""
    }
  })
}

mountSignupTimezone()
